import React, {Component} from 'react';
import {connect} from 'react-redux';
import $ from "jquery";
import {bindActionCreators} from 'redux';
import {withRouter} from "react-router-dom";

import {fetchPostDetails,showCarousal} from "../../../actions/feedAction";
import FeedContent from "./../../FeedContainer/FeedContent"
import FeedUser from "./../../FeedContainer/FeedUser"
import FeedImage from "./../../FeedContainer/FeedImage"
import FeedFooter from "./../../FeedContainer/FeedFooter"
import FeedMenu from "./../../FeedContainer/FeedMenu";
import ShareFeed from "./../../FeedContainer/ShareFeed";
import { decrypt } from "../../../helpers/CryptoJs";
import {Pageloader} from "./../../Pageloader"
import './Post.css';

class Post extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentFeed         : {},
      toggleStatus        : '',
      toggle_feed_id      : '',
      urlFeedId           : this.props.urlFeedId,
      currentActiveImage  : 0,
      carousalFeed        : 0
    };
    this.fetchPost      = this.fetchPost.bind(this);
    this.toggleFunction = this.toggleFunction.bind(this);
    this.setActiveImage  = this.setActiveImage.bind(this);
  }
  componentDidMount(){
    this.fetchPost(this.state.urlFeedId);
  }
  
  setActiveImage(activeIndex,feedId){
    let param = {
      activeIndex  : activeIndex,
      carousalFeed : feedId
    };
    this.props.showCarousal(param);
  }

  fetchPost(feedId){
    this.props.fetchPostDetails(feedId);
  }
  
  toggleFunction(toggleFeed){
    this.setState({
      toggleStatus    : (this.state.toggleStatus == 'is-collapsed') ? '' : 'is-collapsed',
      toggle_feed_id  : toggleFeed
    });
  }
  UNSAFE_componentWillReceiveProps(nextProps,prevProps){

    let url = window.location.href.split('/');
    //console.log(url);
   
    let urlval = decrypt(url.pop());
    if(urlval != this.state.urlFeedId){
      this.setState({
        urlFeedId : urlval
      },function(){
        this.fetchPost(this.state.urlFeedId);
      })       
    }
  
    //console.log('cur',nextProps.urlFeedId,'prev',this.props.urlFeedId);

    if(nextProps.imagecarousal != this.props.imagecarousal){
      this.setState({
        currentActiveImage      : nextProps.imagecarousal.activeIndex,
        carousalFeed            : nextProps.imagecarousal.carousalFeed,
      })
    }

    /*  let matchedIndex = (totalFeedObj).map(function (obj) { 
      return obj.feed_id; 
    }).indexOf(nextProps.updatelikelist.feed_id); */
    
    
    if((nextProps.updatelikelist.feed_id != '') && (nextProps.updatelikelist.feed_id !== undefined)){
      nextProps.postDetail.my_reaction    = nextProps.updatelikelist.my_reaction;
      nextProps.postDetail.total_reaction = nextProps.updatelikelist.total_reaction;

      this.setState({
        currentFeed       : nextProps.postDetail,
      }) 

    }else if(nextProps.lastEditedPost.editPost.post_id !== undefined){
      this.setState({
        currentFeed       : nextProps.lastEditedPost.editPost.post_details,
      }) 
      
    }else{
      this.setState({
        currentFeed       : nextProps.postDetail,
      })
    }
    

    if(this.state.urlFeedId == nextProps.delete.feed_id){ 
        this.props.history.push('/feed');
    }
    
  }
  generateFeedContent(feedList){
   
    let details = feedList;
      return (
        <div className="post_box">
          <div className="center_post">
            <div className="post_header">
              <FeedUser post_user={details.post_user} post_date={details.post_date}/>
              <FeedMenu 
              feed_id       ={details.feed_id} 
              post_id       ={details.post_id} 
              data_type     ={details.data_type} 
              toggle_feed_id={this.state.toggle_feed_id} 
              toggleStatus  ={this.state.toggleStatus} 
              toggleFunction={this.toggleFunction} 
              logged_in_user={this.props.currentUserDetails}  
              post_user     ={details.post_user} 
              position      ="post"
            
              />
            </div>
            <div className="post_body">
              <FeedContent content={details.content}/> 
              {this.checkPostImage(details)}
              {this.checkSharedPost(details)}
            </div>
          </div>
          <FeedFooter 
            total_reaction={details.total_reaction} 
            my_reaction={details.my_reaction} 
            total_comment={details.total_comment} 
            total_share={details.total_share} 
            data_type={details.data_type} 
            feed_id={details.feed_id} 
            post_id={details.post_id}
            position="post" 
            feed_reaction_details = {details.feed_reaction_details} 
          />
          
        </div>
      )
    
  }
  checkSharedPost(details){
    return(
      ((details.post_user_from != undefined) && (details.post_user_from.post_user_from_id != '')) ? 
      <ShareFeed parent_post = {details.post_user_from} data_type={details.data_type}/>          
      : null
    )
  }
  checkPostImage(details){
    return (
      (details.media_link != '') ? 
          <div className="post_content">
            <FeedImage 
              media_details      = {details.media_details}
              dynamic_class      = "post_img" 
              setActiveImage     = {this.setActiveImage} 
              currentFeed        = {this.state.urlFeedId}
              currentActiveImage = {this.state.currentActiveImage} 
              carousalFeed       = {this.state.carousalFeed} 
              post_my_reaction   = {details.my_reaction}
              post_total_reaction= {details.total_reaction}
              post_total_comment = {details.total_comment}
              post_total_share   = {details.total_share}
            />
          </div>
      : null
    )
  }
  render() {
    let feedList = this.state.currentFeed || {};
    let feedBox = this.generateFeedContent(feedList);
    
    return (
      <div id="post_arr">
        {(Object.keys(feedList).length > 0) ? feedBox : null}
       {/*  <Pageloader/> */}
      </div>
    );
  }
}
const mapStateToProps = state => {
  
  return {
    postDetail      : state.postdetail.postDetail, 
    lastCreatedPost : state.lastpost,
    updatelikelist  : state.updatelikelist.likeFeedResponse,
    imagecarousal   : state.imagecarousal.imageCarousal,
    delete          : state.deletepost.deletePost,
    lastEditedPost  : state.editpost,
  }
}
const mapDispatchToProps = dispatch => {
  return {
    fetchPostDetails: bindActionCreators(fetchPostDetails, dispatch),
    showCarousal    : bindActionCreators(showCarousal, dispatch),
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Post));
